export enum AccountType {

  ADVERTISER = 'ADVERTISER',
  PUBLISHER = 'PUBLISHER',
  UNRECOGNISED = 'UNRECOGNISED',

}

export const newAdvertiserAccount = (
  accountId: number,
  name?: string,
): AdvertiserAccount =>
  ({
    accountId,
    accountType: AccountType.ADVERTISER,
    name,
  });

export const newPublisherAccount = (
  accountId: number,
  name?: string,
  tagIds?: number[],
  promotionalTypeIds?: number[],
): PublisherAccount =>
  ({
    accountId,
    accountType: AccountType.PUBLISHER,
    name,
    tagIds,
    promotionalTypeIds,
  });

export const isAdvertiser = (account: AccountIdentity) => account.accountType === AccountType.ADVERTISER;
export const isPublisher = (account: AccountIdentity) => account.accountType === AccountType.PUBLISHER;

export const sameAccount = (a: AccountIdentity, b: AccountIdentity) =>
  a.accountId === b.accountId && a.accountType === b.accountType;

export interface AccountIdentity {

  readonly accountId: number;
  readonly accountType: AccountType;

}

export interface AdvertiserAccount extends AccountIdentity {

  readonly accountType: AccountType.ADVERTISER;

  readonly name?: string;

}

export interface PublisherAccount extends AccountIdentity {

  readonly accountType: AccountType.PUBLISHER;

  readonly name?: string;
  readonly tagIds?: number[];
  readonly promotionalTypeIds?: number[];

}

export type Account = AdvertiserAccount | PublisherAccount;
